<div class="form-element">
    <p-inputSwitch (onChange)="change.emit($event)" [(ngModel)]="value" [disabled]="disabled" [readonly]="readonly"
        [styleClass]="styleClass" [style]="style">
    </p-inputSwitch>
    <label *ngIf="label">{{ label }}</label>
    <cap-validator *ngIf="control" [control]="control" [customName]="label"></cap-validator>
</div>
